module.exports = __webpack_public_path__ + "static/media/lambda-badge.df29d338.png";